/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assignFilter = _interopRequireDefault(require("../../packages/assign-filter"));
function isDefined(value) {
  return value !== undefined;
}
var _default = function _default(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  return _assignFilter.default.apply(void 0, [isDefined, target].concat(sources));
};
exports.default = _default;